<template>
  <div class="chat-widget__file">
    <div class="chat-widget__file-info">
      <i class="pi pi-file"/>
      <span :class="['chat-widget__file-name', { 'chat-widget__file-name--ellipsis': statMessage }]"
            v-tooltip.bottom="file.filename">{{ file.filename }}</span>
      <span class="chat-widget__file-meta" v-if="statMessage">
        ({{ statMessage }})
      </span>
    </div>
    <div>
      <Button variant="text"
              icon="pi pi-download"
              v-if="file.type !== FILE_TYPE_ATTACHMENT_LINK"
              @click="downloadFileAsBlob(file.url, file.filename)"
      />
      <Button variant="text"
              icon="pi pi-trash"
              v-if="showDeleteButton"
              @click="handleDeleteAssistant(file.id)"
      />
    </div>
  </div>
</template>
<script setup>
import Button from 'primevue/button';
import {computed, onMounted, ref} from "vue";
import {downloadFileAsBlob, formStatMessage} from "@/services/helper";
import {FILE_TYPE_ATTACHMENT_LINK} from "@/constants";
import {useConfirm} from "primevue/useconfirm";
import {useAppStateStore} from "@/modules/chat/stores/appStore";
import {useChatStore} from "@/modules/chat/stores/chatStore";

const props = defineProps({
  file: {
    type: Object,
    required: true
  },
  messageId: {
    type: String,
    required: true
  }
});

const statMessage = ref('');

onMounted(() => {
  statMessage.value = formStatMessage(props.file);
});

const showDeleteButton = computed(() => useAppStateStore().authorized);

const confirm = useConfirm();
const handleDeleteAssistant = async (id) => {
  confirm.require({
    message: 'Подтвердите удаление файла. Операция необратима. Файл будет исключен из контекста диалога.',
    header: 'Удаление файла',
    icon: 'pi pi-info-circle',
    rejectLabel: 'Отмена',
    rejectProps: {
      severity: 'secondary',
      outlined: true
    },
    acceptProps: {
      label: 'Удалить',
      severity: 'danger'
    },
    accept: async () => {
      await useChatStore().deleteFile(id);

      // удалить из списка файлов сообщения
      const message = useChatStore().messages.find(message => message.id === props.messageId);
      if (message) {
        message.files = message.files.filter(file => file.id !== id);
      }
    },
  });
};
</script>
